module.exports = __webpack_public_path__ + "media/src/images/notif_mailer/header-logo-70ebde311aaf29c7c16a63e5efab441d.png";